import React, { PureComponent, createElement } from 'react';
import format from 'date-fns/format';
import { timeout } from 'd3-timer';

import Text from '../Text';
import Box from '../Box';
import Button from '../Button';
import { withReduxContext } from '../../stores/surveyStore';

class WithTimer extends PureComponent {
  static getDerivedStateFromProps({ timers, name, value }) {
    const hasValue = typeof value !== 'undefined';
    return {
      hasValue,
      lockAnswer: timers[name] && hasValue,
    }
  }

  state = {
    start: null,
    lockAnswer: false,
  }

  // componentDidUpdate() {
  //   if (typeof this.props.value !== 'undefined') {
  //     this.counterStopped = true;
  //   }
  // }

  componentWillUnmount() {
    if (!this.counterStopped && this.startTime) {
      const { name, setTimer } = this.props;
      setTimer({ name, value: new Date() - this.startTime });
    }
    if (this.timer) {
      this.timer.stop();
    }
  }

  handleStart = () => {
    if (this.counterStarted) return;
    this.counterStarted = true;
    this.startTime = new Date();
    this.timer = timeout(this.handleTick, 1000);
    this.setState({ start: true });
  }

  handleTick = () => {
    if (this.counterStopped) return;
    if (this.timerRef) {
      this.timerRef.innerText = format(new Date() - this.startTime, 'mm:ss');
      this.timer = timeout(this.handleTick, 1000);
    }
  }

  handleTimerRef = (ref) => {
    this.timerRef = ref;
  }

  handleLock = () => {
    this.counterStopped = true;
    // this.setState({ lockAnswer: true })
    const { name, setTimer } = this.props;
    setTimer({ name, value: new Date() - this.startTime });
  }

  render() {
    const { comp, setTimer, timers, ...props } = this.props;
    const { start, hasValue, lockAnswer } = this.state;
    return (
      <div>
        {!start && !hasValue && (
          <Box
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            bg="rgba(255,255,255,0.97)"
            zIndex={1}
            align="center"
            pt="4rem"
          >
            <Text align="center" fontSize="1.25em" my="0.5em">點擊回答下一題</Text>
            <Button type="button" onClick={this.handleStart}>我準備好了</Button>
          </Box>
        )}
        {createElement(comp, Object.assign(props, lockAnswer ? { readOnly: true } : {}))}
        {(start || hasValue) && (
          <Text align="right" mx="0.5em" my="1em" color="gray">
            花費時間：
            {lockAnswer ? format(timers[props.name], 'mm:ss') : <span ref={this.handleTimerRef}>00:00</span>}
            {!lockAnswer && (
              <Button
                type="button"
                fontSize="1em"
                mx="1em"
                px="1em"
                display="inline"
                onClick={this.handleLock}
                disabled={props.value === undefined}
              >鎖定答案！</Button>
            )}
          </Text>
        )}
      </div>
    );
  }
}

const WithContexTimer = withReduxContext(WithTimer);

export default (SubComp) => ({ timer, ...props }) => timer ?
  createElement(WithContexTimer, { comp: SubComp, ...props }) :
  <SubComp {...props} />;
